import { useCallback } from 'react'
import ym from 'react-yandex-metrika'

export const GOALS = {
  PAGE_HOME: 'page_home',
  PAGE_TRAINS: 'page_trains', 
  PAGE_TRAIN_DETAIL: 'page_train_detail',
  PAGE_EQUIPMENTS: 'page_equipments',
  PAGE_SUBSCRIPTION: 'page_subscription',
  PAGE_PURCHASE: 'page_purchase',
  PAGE_MORE: 'page_more',
  PAGE_PROGRESS: 'page_progress',
  PAGE_ONBOARDING: 'page_onboarding',
  PAGE_WAY_TO_GOAL: 'page_way_to_goal',
  PAGE_BODY_FORM: 'page_body_form',
  PAGE_GIRL_BODY_FORM: 'page_girl_body_form',
  PAGE_FREE_TRAINS: 'page_free_trains',
  PAGE_FREE_TRAIN_DETAIL: 'page_free_train_detail',
  PAGE_RECOMMEND_TEMPLATE: 'page_recommend_template',
  PAGE_RECOMMEND_TRAIN: 'page_recommend_train',
  PAGE_OWN_OFFICE: 'page_own_office',
  PAGE_OWN_OFFICE_CUSTOMERS: 'page_own_office_customers',
  PAGE_OWN_OFFICE_STATS: 'page_own_office_stats',
  PAGE_OWN_OFFICE_CLIENT: 'page_own_office_client',
  PAGE_ADMIN: 'page_admin',
  PAGE_ADMIN_USERS: 'page_admin_users',
  PAGE_ADMIN_USER_DETAIL: 'page_admin_user_detail',
  PAGE_ADMIN_DASHBOARD: 'page_admin_dashboard',

  BUTTON_START: 'button_start',
  BUTTON_EXERCISE: 'button_exercise',
  BUTTON_REPLACE: 'button_replace',
  BUTTON_CONFIGURE_EQUIPMENT: 'button_configure_equipment',
  BUTTON_WRITE_TRAINER: 'button_write_trainer',
  BUTTON_WRITE_SUPPORT: 'button_write_support',
  BUTTON_VIEW_SUBSCRIPTION: 'button_view_subscription',
  BUTTON_SELECT_TARIFF: 'button_select_tariff',
  BUTTON_ENTER_EMAIL: 'button_enter_email',
  BUTTON_REQUEST_PAYMENT: 'button_request_payment',
  BUTTON_ADAPT: 'button_adapt',
  BUTTON_REGENERATE: 'button_regenerate',
  BUTTON_EQUIPMENT_CLICK: 'button_equipment_click',
  BUTTON_MOVE_TRAINING: 'button_move_training',
  BUTTON_SKIP_EQUIPMENT: 'button_skip_equipment',

  ACTION_TRAINING_STARTED: 'action_training_started',
  ACTION_EXERCISE_STARTED: 'action_exercise_started',
  ACTION_TARIFF_SELECTED: 'action_tariff_selected',
  ACTION_PAYMENT_REQUESTED: 'action_payment_requested',
  ACTION_EQUIPMENT_SELECTED: 'action_equipment_selected',
  ACTION_ADAPTATION_STARTED: 'action_adaptation_started',
  ACTION_REGENERATION_STARTED: 'action_regeneration_started',
  ACTION_SUBSCRIPTION_VIEWED: 'action_subscription_viewed',
  ACTION_EMAIL_ENTERED: 'action_email_entered',
  ACTION_TRAINER_CONTACTED: 'action_trainer_contacted',
  ACTION_SUPPORT_CONTACTED: 'action_support_contacted',

  // Онбординг и выбор формы тела
  ONBOARDING_STARTED: 'onboarding_started',
  ONBOARDING_STEP_COMPLETED: 'onboarding_step_completed',
  ONBOARDING_COMPLETED: 'onboarding_completed',
  BODY_FORM_STARTED: 'body_form_started',
  BODY_FORM_COMPLETED: 'body_form_completed',
  GIRL_BODY_FORM_STARTED: 'girl_body_form_started',
  GIRL_BODY_FORM_COMPLETED: 'girl_body_form_completed',
  WAY_TO_GOAL_STARTED: 'way_to_goal_started',
  WAY_TO_GOAL_COMPLETED: 'way_to_goal_completed',
  SURVEY_MODAL_OPENED: 'survey_modal_opened',
  SURVEY_MODAL_COMPLETED: 'survey_modal_completed',
} as const

export type GoalName = typeof GOALS[keyof typeof GOALS]

export const useYandexMetrika = () => {
  const reachGoal = useCallback((goalName: string, params?: Record<string, any>) => {
      if (typeof ym === 'function') {
        ym('reachGoal', goalName, params)
      }
  }, [])

  const hit = useCallback((url: string, title?: string, params?: Record<string, any>) => {
      if (typeof ym === 'function') {
        ym('hit', url, title, params)
      }
  }, [])

  const trackPageView = useCallback((pageName: GoalName, params?: Record<string, any>) => {
    reachGoal(pageName, params)
  }, [reachGoal])

  const trackButtonClick = useCallback((buttonName: GoalName, params?: Record<string, any>) => {
    reachGoal(buttonName, params)
  }, [reachGoal])

  const trackAction = useCallback((actionName: GoalName, params?: Record<string, any>) => {
    reachGoal(actionName, params)
  }, [reachGoal])

  return {
    reachGoal,
    hit,
    trackPageView,
    trackButtonClick,
    trackAction,
    GOALS
  }
}
